// Source/Collection-Card/Poll.ts
function pollFor(args) {
  const {
    interval = 100,
    selector,
    timeout = 1e4
  } = args;
  const start = Date.now();
  return new Promise((resolve, reject) => {
    const instance = setInterval(() => {
      try {
        const element = document.querySelector(selector);
        if (element) {
          clearInterval(instance);
          resolve(element);
          return;
        }
        const delta = Date.now() - start;
        if (delta >= timeout) {
          clearInterval(instance);
          reject();
          return;
        }
      } catch (exception) {
        console.error(exception);
      }
    }, interval);
  });
}

// Source/Collection-Controls/mod.ts
var Element = {
  Filters: `#boost-sd_filter-tree-mobile .boost-sd__filter-tree-vertical-option-list`,
  Self: `.Filter-Toggle`
};
pollFor({ selector: Element.Filters }).then(setup).catch(() => {});
window.addEventListener("Boost:After-Render", setup);
function setup() {
  const self = document.querySelector(Element.Self);
  if (self)
    return;
  console.debug(`Boost collection controls patch setup`);
  const filters = document.querySelector(Element.Filters);
  if (!filters)
    return;
  const button = makeElement();
  filters.parentElement.insertBefore(button, filters);
}
function makeElement() {
  const id = crypto.randomUUID();
  const input = document.createElement("input");
  input.type = "checkbox";
  input.id = id;
  const label = document.createElement("label");
  label.textContent = "Filter";
  label.htmlFor = id;
  const container = document.createElement("div");
  container.className = "Filter-Toggle";
  container.append(input, label);
  return container;
}
